import cloneDeep from 'lodash.clonedeep';
import merge from 'lodash.merge';

/**
 * Merges objects in safe way (without modifying any of the props)
 */
const mergeDeepSafe = <TTarget, TSource>(
  target: TTarget,
  source: TSource,
): TTarget & TSource => merge(cloneDeep(target), source);

export default mergeDeepSafe;
